// extracted by mini-css-extract-plugin
export default {"noCommentContainer":"TaskComments_noCommentContainer__m6cVa"};